const CURRENCY_F_REGEX = /(\d[\d\s.,\u00A0\u202F]*)\s?F\b/g;

const EXCLUDED_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'OPTION']);

const shouldSkipNode = node => {
  if (!node || !node.parentElement) return true;
  return EXCLUDED_TAGS.has(node.parentElement.tagName);
};

const normalizeTextNode = node => {
  if (!node || node.nodeType !== Node.TEXT_NODE || shouldSkipNode(node)) return;
  const original = node.textContent || '';
  if (!original.includes('F')) return;

  const normalized = original.replace(CURRENCY_F_REGEX, (_, amount) => `${amount.trimEnd()} FCFA`);
  if (normalized !== original) {
    node.textContent = normalized;
  }
};

const normalizeSubtree = root => {
  if (!root) return;

  if (root.nodeType === Node.TEXT_NODE) {
    normalizeTextNode(root);
    return;
  }

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let current = walker.nextNode();
  while (current) {
    normalizeTextNode(current);
    current = walker.nextNode();
  }
};

export const startCurrencyNormalization = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return () => {};
  }

  normalizeSubtree(document.body);

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === 'characterData') {
        normalizeTextNode(mutation.target);
      }

      mutation.addedNodes.forEach(node => {
        normalizeSubtree(node);
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  return () => observer.disconnect();
};

